import React from "react";
import classNames from "./classNames";

const LoadingSkeleton = ({ count = 1, variant = "line", className, label = "Loading" }) => (
  <div className={classNames("loading-skeleton", className)} role="status" aria-label={label}>
    {Array.from({ length: Math.max(1, count) }, (_, index) => (
      <span
        className={classNames("loading-skeleton__item", `loading-skeleton__item--${variant}`)}
        key={index}
        aria-hidden="true"
      />
    ))}
    <span className="visually-hidden">{label}</span>
  </div>
);

export default LoadingSkeleton;
